export * from './konstante'
